import React,{useState} from "react";
import Slide1 from "../images/H1.jpeg";
import Slide2 from "../images/H2.jpeg";

function Carousel(){
    const [first,setFirst] = useState(false);
    setTimeout(() => {
        setFirst(!first);
    },5000)
    
    return(
        <div className="relative align-center transition-all duration-300 ease-in-out">
            {
                first ? (
                    <div className="relative text-center">
                        <div className="absolute top-24 left-2 md:top-24 md:left-10 lg:left-14 lg:top-40 text-left animate-slideInLeft">
                            <p className="text-sky-400 text-2xl md:text-5xl lg:text-7xl font-light ">Make <strong className="uppercase">Physics</strong></p>
                            <p className="text-sky-200 text-xl md:text-4xl lg:text-6xl font-light ">The most scoring subject</p>
                        </div>
                        <img className="flex h-64 w-auto md:h-80 md:w-auto lg:h-auto" src={Slide1} alt="" />
                    </div>
                ) : 
                (
                    <div className="relative text-center">
                        <div className="absolute right-2 top-24 md:right-10 md:top-28 lg:right-14 lg:top-40 text-right animate-slideInRight">
                            <p className="text-white text-lg md:text-4xl lg:text-7xl font-light ">Result Oriented Institute In</p>
                            <p className="text-slate-200 text-lg md:text-2xl lg:text-6xl font-light ">JEE | NEET | CET | NATA</p>
                        </div>
                        <img className="flex h-64 w-auto md:h-80 md:w-auto lg:h-auto" src={Slide2} alt="" />
                    </div>
                )
            }
        </div>
    )
}

export default Carousel;